export default "__VITE_ASSET__D9VCU0ML__"